export default {
  name: {
    id: 'rm_metal_arsenic_name',
    defaultMessage: 'Arsenic',
  },
  smartphoneLabel: {
    id: 'rm_metal_arsenic_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_arsenic_what_it_does',
    defaultMessage:
      'In some display components, arsenic helps gallium arsenide (GaAs) LEDs emit orange-red light. In chips, tiny amounts of arsenic are added to silicon to provide extra electrons. This controlled process gives silicon the electrical properties needed to control how electricity moves through transistors, allowing them to switch on and off and process information.',
  },
  extractionText1: {
    id: 'rm_metal_arsenic_extraction_p1',
    defaultMessage:
      'Arsenic is rarely mined directly today. It is mainly recovered as a by-product of smelting gold, copper, cobalt and lead ores. Arsenic trioxide is collected from flue dust, purified and then reduced to produce arsenic metal. Further purification produces the high-purity arsenic used in semiconductor materials, including gallium arsenide (GaAs), and to give silicon the electrical properties needed for transistors.',
  },
  quickFactText: {
    id: 'rm_metal_arsenic_quick_fact',
    defaultMessage:
      'Almost 100% of the European Union’s arsenic metal imports came from China in 2024, while all documented recycling indicators remained below 1%.',
  },
  envSummaryText: {
    id: 'rm_metal_arsenic_env_summary',
    defaultMessage:
      'Arsenic is recovered from residues left by copper, gold, lead and cobalt processing. It is converted into stable compounds and stored to reduce pollution, but inorganic arsenic can contaminate water, food and farmland. Its use and disposal are subject to increasingly strict environmental rules.',
  },
  envWaterText: {
    id: 'rm_metal_arsenic_env_water_text',
    defaultMessage:
      'Arsenic can enter drinking and irrigation water through contaminated mine drainage. When sulfide-rich ores are exposed to air and water, they can generate acid mine drainage. The resulting acidity can dissolve and mobilise arsenic and other toxic elements, allowing them to leach into soil, groundwater and rivers over many kilometres.',
  },
  envSoilText: {
    id: 'rm_metal_arsenic_env_soil_text',
    defaultMessage:
      'Arsenic can enter soil through contaminated irrigation water, industrial processes and the disposal of arsenic-bearing residues. Acid mine drainage forms when sulfide minerals react with air and water, creating acidic conditions that mobilise arsenic and other heavy metals. Secure storage and treatment of mining waste can reduce pollution risks.',
  },
  humanSummaryText: {
    id: 'rm_metal_arsenic_human_summary',
    defaultMessage:
      'Arsenic is highly toxic. Long-term exposure to inorganic arsenic, mainly through drinking water and food, can lead to chronic arsenic poisoning, skin lesions and skin cancer. People can also be exposed through contaminated water used to prepare food or irrigate crops, industrial processes, contaminated food and tobacco smoke.',
  },
  humanHealthText: {
    id: 'rm_metal_arsenic_human_health_text',
    defaultMessage:
      'Long-term exposure to inorganic arsenic can lead to chronic arsenic poisoning. The most characteristic effects are skin lesions and skin cancer. The European Union has regulations limiting arsenic levels in water and food.',
  },
  humanLegalText: {
    id: 'rm_metal_arsenic_human_legal_text',
    defaultMessage:
      'The European Union has regulations limiting arsenic levels in water and food. Regulations on arsenic use, emissions and disposal are becoming increasingly stringent.',
  },
  geoSummaryText: {
    id: 'rm_metal_arsenic_geo_summary',
    defaultMessage:
      'Arsenic supply is highly concentrated at the import stage. In 2024, China supplied close to 100% of the European Union’s arsenic metal imports. China also supplied 96% of U.S. arsenic metal imports through July 2024. This dependence could leave both markets vulnerable to trade restrictions or disruptions affecting Chinese supply.',
  },
  geoDugText: {
    id: 'rm_metal_arsenic_geo_dug_text',
    defaultMessage:
      'Arsenic trioxide is produced mainly in Peru, China and Morocco. In 2024, these three countries were the leading producers, together accounting for about 95% of estimated global production. Arsenic is rarely mined directly and is mainly recovered as a by-product of processing gold, silver, copper and lead ores.',
  },
  geoProcessedText: {
    id: 'rm_metal_arsenic_geo_processed_text',
    defaultMessage:
      'Arsenic trioxide refining capacity is concentrated but distributed across several countries. In 2024, Peru accounted for around 46% of global capacity, China for 37% and Morocco for nearly 10%.',
  },
  geoLeverageText: {
    id: 'rm_metal_arsenic_geo_leverage_text',
    defaultMessage:
      'No export restrictions has been documented. However, China supplied close to 100% of EU arsenic metal imports in 2024 and 96% of U.S. arsenic metal imports through July 2024. Any future restriction or disruption affecting Chinese supply could therefore quickly affect European and U.S. markets.',
  },
  supplySummaryText: {
    id: 'rm_metal_arsenic_supply_summary',
    defaultMessage:
      'Arsenic supply depends mainly on by-product recovery from copper, gold, silver and lead processing. The European Union relies heavily on imports from China, while stricter environmental regulations may constrain production. Future demand is technology-dependent: high-purity arsenic remains important for GaAs semiconductors, and if GaAs-based solar cells scale up, demand for arsenic and gallium could rise together.',
  },
  supplyReservesText: {
    id: 'rm_metal_arsenic_supply_reserves_text',
    defaultMessage:
      'No reliable global reserve estimate exists because arsenic is mainly recovered as a by-product and is not separately quantified. Finland has an unexploited resource of around 2,400 tonnes of arsenic metal, but no European arsenic deposit is currently operating or considered economically feasible.',
  },
  supplyDemandText: {
    id: 'rm_metal_arsenic_supply_demand_text',
    defaultMessage:
      'Overall arsenic demand could decline as environmental regulations become stricter. However, high-purity arsenic will remain important for GaAs and related semiconductors used in mobile devices, solar cells, satellites, wireless communications, and military and aerospace equipment. For solar PV alone, arsenic demand in 2050 is projected to be 30 times its 2030 level.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_arsenic_recycling_summary',
    defaultMessage:
      'No documented recycling system exists for arsenic. The old scrap ratio, recycled content and end-of-life recycling rate are all below 1%.',
  },
  recyclingInputText: {
    id: 'rm_metal_arsenic_recycling_input_text',
    defaultMessage:
      'Documented recycling of arsenic is negligible, with available recycling indicators below 1%. No established industrial recycling process or higher recent recycling rate has been documented, although vacuum pyrolysis has been proposed for recovering arsenic from GaAs-based e-waste.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_arsenic_recycling_outlook_text',
    defaultMessage:
      'Not currently. Arsenic recycling is not documented at industrial scale, and all reported recycling indicators remain below 1%. Supply therefore remains dependent on primary recovery from copper, gold, lead and cobalt processing.',
  },
  footnote1Text1: {
    id: 'rm_metal_arsenic_footnote_1_p1',
    defaultMessage:
      'As arsenic is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  mine0Region: {
    id: 'rm_metal_arsenic_mine0_region',
    defaultMessage: 'Gejiu',
  },
  mine1Region: {
    id: 'rm_metal_arsenic_mine1_region',
    defaultMessage: 'Zhuzhou',
  },
  mine2Region: {
    id: 'rm_metal_arsenic_mine2_region',
    defaultMessage: 'Marrakech',
  },
  mine3Region: {
    id: 'rm_metal_arsenic_mine3_region',
    defaultMessage: 'Ilo',
  },
  mine4Region: {
    id: 'rm_metal_arsenic_mine4_region',
    defaultMessage: 'Antwerp',
  },
} as const
